$(() => {
  $('.extra-carousel-video-autoplay').each((index, carousel) => { 
    initializeFlickity(carousel);
    handleWindowLoad(carousel);
  });
});

function initializeFlickity(carousel) {
  $(carousel).on('ready.flickity', (readyEvent) => {
    const autoPlayDuration = $(readyEvent.target).data('autoplay');
    const pageDots = $(readyEvent.target).data('pagedots');
    
    if (autoPlayDuration && pageDots) {
      setupPageDots(readyEvent.target, autoPlayDuration);
    }
    
    $(carousel).on('change.flickity', (event, slideNo) => handleSlideChange(event, slideNo));
  });
}

function setupPageDots(target, autoPlayDuration) {
  $(target).find('ol.flickity-page-dots .dot').each((index, dotElement) => {
    $(dotElement).append('<span></span>');
    $(dotElement).find('span').css('animation-duration', `${autoPlayDuration}ms`);
  });
}

function handleSlideChange(event, slideNo) {
  const flickity = $(event.target).data('flickity');
  
  if (!flickity?.cells) return;
  
  flickity.cells.forEach((cell, index) => {
    if (cell?.element) {
      handleVideoPlayback(cell.element, index === slideNo);
    }
  });
}

function handleVideoPlayback(element, isActive) {
  $(element).find('video').each((_, videoElement) => {
    if (isActive) {
      videoElement.play();
    } else {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
  });
}

function handleWindowLoad(carousel) {
  $(window).on('load', () => {
    const flickity = $(carousel).find('.flickity-enabled').data('flickity');
    
    if (!flickity?.cells) return;
    
    const activeSlideIndex = flickity.selectedIndex;
    
    flickity.cells.forEach((cell, index) => {
      if (cell?.element) {
        const $cellElement = $(cell.element);
        const isActive = index === activeSlideIndex && 
          !$cellElement.hasClass('is-previous') && 
          !$cellElement.hasClass('is-next');
        handleVideoPlayback(cell.element, isActive);
      }
    });
  });
}
